import React, { useEffect, useState } from 'react'
import axios from "axios"
import { Link,useNavigate } from 'react-router-dom'

function Signup() {
    let navigate = useNavigate()
    let [userExist, setUserExist] = useState([])
    let [alertExist,setAlertExist]  = useState({existEmail:"",existUsername:""})

    let getUsers = async() => {
        let res = await fetch(`https://backend-todolist.vercel.app/getUsers`)
        let json = await res.json()
        return json
      }
      useEffect(() => {
        getUsers().then(res => setUserExist(res))
      }, [])

      





    let [signupValue, setSignupValue] = useState({
        username: "",
        email: "",
        password: "",
        rePassword: "",
        todoList: []
    })



    let handleChange = (e) => {

       
            setSignupValue({ ...signupValue, [e.target.name]: e.target.value })
            
       
    }

    let handleSubmit =  (e) => {
        e.preventDefault()


        if (userExist.some(item => item.email === signupValue.email )) {
            // alert("This E-Mail is already exist")
            setAlertExist({existEmail:"This E-Mail is already exist"})
        } else if(userExist.some(item => item.username === signupValue.username  )) {
            // alert("This Username is already exist")
            setAlertExist({existUsername:"This Username is already exist"})

            
        } else {
           axios.post(`https://backend-todolist.vercel.app/users`, {
                username: signupValue.username,
                email: signupValue.email,
                password: signupValue.password,
                todoList:[]            
            })
            setSignupValue({
                username: "",
            email: "",
            password: "",
            rePassword: "",
            })
            
            navigate("/") // this means to sign in
        }


       
        

    }
    console.log(signupValue);
    console.log("UserExist",userExist);
  return (
    <div className='signup'>
    <h1>Welcome to Sign up </h1>
    <form onSubmit={handleSubmit}>
              <input value={signupValue.username} required onChange={handleChange} type="text" name="username" placeholder='Username...' />
              <b>{ alertExist.existUsername}</b>
              <input value={signupValue.email} required onChange={handleChange} type="email" name="email" placeholder='E-Mail...' />
              <b>{ alertExist.existEmail}</b>
              
        <input value={signupValue.password} required onChange={handleChange} type="password" name="password"  placeholder='Password...' minLength={5}  />
              <input value={signupValue.rePassword} required onChange={handleChange} type="password" name="rePassword" placeholder='Repeat Password...' />
              <b >{ signupValue.rePassword !== signupValue.password ? "Repeat password is not matching" : ""}</b>
        <button disabled={signupValue.password !== signupValue.rePassword}>Sign up</button>
    </form>
    <h3>Back to <Link to="/">Sign in</Link></h3>
</div>
  )
}

export default Signup